// extracted by mini-css-extract-plugin
module.exports = {"skeleton-main-body":"SkeletonLoader_skeleton-main-body__1ZsSP","shimmer":"SkeletonLoader_shimmer__Uy7qn"};